import { render, staticRenderFns } from "./MappingProcess.vue?vue&type=template&id=8ef2b804"
import script from "./MappingProcess.vue?vue&type=script&lang=js"
export * from "./MappingProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports